/**
 * The board screen's host for the widget canvas (`specs/M10-D1-dashboards.md` §8.1).
 *
 * A board view whose registry id is `dashboard` renders this instead of the table — the same
 * branch a form view already gets. Its canvas aggregates the board it lives on.
 */
import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { WidgetCanvas } from './WidgetCanvas';
import { useDashboardSource } from './hooks';
import { useMeasureTitles } from './measure-titles';

export function BoardWidgetView({ boardId, viewId }: { boardId: string; viewId: string }) {
  const navigate = useNavigate();
  const boardIds = useMemo(() => [boardId], [boardId]);
  const source = useDashboardSource({ kind: 'board_view', id: viewId }, { boardIds });
  const measureTitle = useMeasureTitles(boardIds);
  return (
    <div data-testid="board-widget-view" data-board-id={boardId} data-view-id={viewId}>
      {/*
        **P-184.** `WidgetCanvas` has carried `showNewItem` / `onNewItem` since M7 and its only
        real caller passed neither, so the board-hosted canvas — the one surface §2.3 puts a
        *New item* button on — never rendered it on any screen. The board's own item-create path
        lives on the table view, so this hands the visitor there rather than opening a second
        composer the canvas would have to own.
      */}
      <WidgetCanvas
        source={source}
        measureTitle={measureTitle}
        showNewItem
        onNewItem={() => navigate(`/boards/${boardId}`)}
      />
    </div>
  );
}
